import { typeahead } from "@mirage/service-typeahead-search/service/types";
import { isInsideExtension } from "@mirage/shared/util/webExtensionsHelpers";
import { useWindowSize } from "@react-hookz/web";
import { atom, useAtom } from "jotai";
import Cookies from "js-cookie";
import { useCallback } from "react";

const HAS_SEEN_OMNIBOX_ASK_TOOLTIP_COOKIE_NAME = "hasSeenOmniboxAskTooltip";

/** THIS IS A SHORT-TERM FIX
 * longer-term we want to persist this server-side, but this is not yet
 * supported by growth.
 *
 * See this slack thread (sorry private channel), but ask Alan for details
 * https://dropbox.slack.com/archives/C08GL2BV7FV/p1746159972515509
 *
 */
const MIN_TOOLTIP_WIDTH = 1200;

const hasSeenOmniboxAskTooltipAtom = atom<boolean | null>(null); // null implies we don't know yet

const getHasSeenAskTooltipCookie = () => {
  const cookie = Cookies.get(HAS_SEEN_OMNIBOX_ASK_TOOLTIP_COOKIE_NAME);
  if (cookie) {
    return cookie === "true";
  }
  return null;
};

const setHasSeenAskTooltipCookie = () => {
  Cookies.set(HAS_SEEN_OMNIBOX_ASK_TOOLTIP_COOKIE_NAME, "true");
};

export const useShowOmniboxAskTooltip = (resultType: typeahead.ResultType) => {
  const { width } = useWindowSize();
  const [hasSeenOmniboxAskTooltip, _setHasSeenOmniboxAskTooltip] = useAtom(
    hasSeenOmniboxAskTooltipAtom,
  );
  const isValidResultType = resultType === typeahead.ResultType.AskUserQuery;
  const isHomePage = window && window.location.pathname === "/";
  const isExtension = isInsideExtension();

  if (isValidResultType && typeof window !== "undefined" && !isExtension) {
    const hasSeenCookieValue = getHasSeenAskTooltipCookie();
    if (hasSeenCookieValue) {
      _setHasSeenOmniboxAskTooltip(true);
    } else {
      _setHasSeenOmniboxAskTooltip(false);
    }
  }

  const setHasSeenOmniboxAskTooltip = useCallback(() => {
    setHasSeenAskTooltipCookie();
    _setHasSeenOmniboxAskTooltip(true);
  }, [_setHasSeenOmniboxAskTooltip]);

  return {
    shouldShowTooltip:
      !isExtension &&
      hasSeenOmniboxAskTooltip === false &&
      isValidResultType &&
      isHomePage &&
      width > MIN_TOOLTIP_WIDTH,
    setHasSeenOmniboxAskTooltip,
  };
};
